export default class TimeRange {
  public from!: number
  public to!: number
}
